import { type ReactNode } from "react";
import { Navigation } from "./Navigation";
import { CartFab } from "@/modules/cart";
import { BuilderOverlay } from "@printtat/builder";
import { frontendBuilderApi } from "@/modules/builder/builderApi";
import { cn } from "@/lib/utils";

interface PersistentLayoutProps {
  children: ReactNode;
  className?: string;
}

export const PersistentLayout = ({ children, className }: PersistentLayoutProps) => {
  return (
    <div className="min-h-screen bg-gray-50 flex">
      {/* Sidebar - Always mounted */}
      <Navigation />

      {/* Main Content - Changes based on route */}
      <div className={cn("flex-1", className)}>{children}</div>

      {/* Floating cart button */}
      <CartFab />

      {/* Builder overlay — renders on top of everything when open */}
      <BuilderOverlay api={frontendBuilderApi} manageLibraryUrl="/assets" />
    </div>
  );
};
